import React, { useEffect } from "react";
import "./myOrders.scss";
import userActivePage from "../../../store/userActivePage";
import orderStore from "../../../store/orderStore";
import paymentStore from "../../../store/paymentStore";
import { Stack } from "@mui/material";
import MyOrderCard from "../../../components/myOrderCard/MyOrderCard";
import orderDeliveryStatusTimeStore from "../../../store/orderDeliveryStatusTimeStore";
import productRatingStore from "../../../store/productRatingStore";
import orderReturnRequestStore from "../../../store/orderReturnRequestStore";
import MyOrderCardSkeleton from "../../../components/myOrderCard/MyOrderCardSkeleton";

const MyOrders = () => {
  const UserActivePage = userActivePage();
  const OrderStore = orderStore();
  const PaymentStore = paymentStore();
  const OrderDeliveryStatusTimeStore = orderDeliveryStatusTimeStore();
  const ProductRatingStore = productRatingStore();
  const OrderReturnRequestStore = orderReturnRequestStore();

  useEffect(() => {
    UserActivePage.setIsActive({ setPage: "my-orders" });
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="my-order">
      <Stack spacing={2} className="w-100 transition">
        <div className="page-title">My Orders</div>
        <div className="content">
          <Stack spacing={2}>
            {OrderStore.isLoading ||
            PaymentStore.isLoading ||
            OrderDeliveryStatusTimeStore.isLoading ||
            OrderReturnRequestStore.isLoading ||
            ProductRatingStore.isLoadingUser ? (
              <MyOrderCardSkeleton />
            ) : OrderStore.orderDetails ? (
              OrderStore.orderDetails
                .slice(0)
                .reverse()
                .map((item) => <MyOrderCard item={item} key={item._id} />)
            ) : (
              <div className="no-order-found">
                <Stack spacing={2}>
                  <div className="title">No order currently placed</div>
                </Stack>
              </div>
            )}
          </Stack>
        </div>
      </Stack>
    </div>
  );
};

export default MyOrders;
